import h, { useRef as g, useEffect as y } from "react";
import { range as p } from "lodash";
import l from "mintel-icons";
import './Icon.css';const S = "#ccc", v = {
  Gray: S
}, _ = (t, s) => ({
  ...t,
  ...s
}), d = (t, s, r, o) => {
  if (!r) return;
  const c = (i, e, n) => {
    const u = `data-original-${e}`;
    i.hasAttribute(u) || i.setAttribute(u, i.getAttribute(e) || ""), n && n.trim() !== "" ? i.setAttribute(e, n) : i.setAttribute(e, i.getAttribute(u) || "");
  };
  p(r.length).forEach((i) => {
    const e = r[i];
    t && e.hasAttribute("fill") && c(e, "fill", o), s && e.hasAttribute("stroke") && c(e, "stroke", o);
  });
}, E = (t, s, r, o, c) => {
  d(s, r, c?.querySelectorAll(".color"), t), d(
    s,
    r,
    c?.querySelectorAll(".alt_color"),
    o
  );
}, q = ({
  name: t = void 0,
  svg: s = void 0,
  size: r = "24px",
  color: o = v.Gray,
  alt_color: c = void 0,
  style: i = {},
  className: e = void 0,
  fillColor: n = !0,
  strokeColor: u = !0,
  ariaHidden: A = !1,
  testId: b = "icon"
}) => {
  const a = g(null);
  let f = s;
  return t && (f = l[t?.replace(/\.svg$/, "")] || l[t]), y(() => {
    t && E(o, n, u, c, a.current);
  }, [t, o, n, u, c, a]), /* @__PURE__ */ h.createElement(
    "span",
    {
      "aria-hidden": A,
      ref: a,
      style: _(i, {
        display: "inline-block",
        width: r,
        height: r
      }),
      className: e,
      dangerouslySetInnerHTML: { __html: f },
      "data-testid": b
    }
  );
};
export {
  q as I,
  v as i
};
